interface LocationInterface {
  pathname: string;
}

const DefaultInterface = {
  pathname: '',
};

export type { LocationInterface };
export { DefaultInterface };